import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgMap(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="3 -4 18 24" {...props}>
      <path
        d="M14.683.053a1 1 0 01.634 0l5 1.67a1 1 0 01.683.949v12.156a1 1 0 01-1.347.938l-4.323-1.598a1 1 0 00-.664-.01l-5.349 1.79a1 1 0 01-.634 0l-5-1.673A1 1 0 013 13.326V1.336a1 1 0 011.317-.95l4.366 1.46a1 1 0 00.634 0zM9 4.026a1 1 0 00-1 1v7a1 1 0 102 0v-7a1 1 0 00-1-1zm6-1.02a1 1 0 00-1 1v7a1 1 0 102 0v-7a1 1 0 00-1-1z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Map')(SvgMap);
